import { render, staticRenderFns } from "./login-with-pwd.vue?vue&type=template&id=60a7c7ae&scoped=true&"
import script from "./login-with-pwd.vue?vue&type=script&lang=js&"
export * from "./login-with-pwd.vue?vue&type=script&lang=js&"
import style0 from "./login-with-pwd.vue?vue&type=style&index=0&id=60a7c7ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a7c7ae",
  null
  
)

export default component.exports